<div class="gov-card">
  <div class="gov-card__header">{{ edit ? 'Edycja przystanku' : 'Dodanie przystanku' }}</div>
  <div class="gov-card__body">
    <form *ngIf="form as form" novalidate autocomplete="off" [formGroup]="form">
      <div class="row">
        <div class="col-md-4">
          <div class='form-group' *ngIf='"roadNumber" as controlName'>
            <label [for]='controlName'>Numer drogi *</label>
            <select
              (change)="roadNumberChange(form.getElement($event).value)"
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [id]='controlName'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              @for (item of roadNumbers(); track $index) {
                <option [value]='item'>{{ item }}</option>
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class="col-md-4">
          <div class='form-group' *ngIf='"roadSide" as controlName'>
            <label [for]='controlName'>Strona drogi *</label>
            <select
              (change)="roadSideChange(form.getElement($event).value)"
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [id]='controlName'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option value='Lewa'>Lewa</option>
              <option value='Prawa'>Prawa</option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class="col-md-4">
          <div class='form-group' *ngIf='"stopNumber" as controlName'>
            <label [for]='controlName'>Nr przystanku *</label>
            <select
              (change)="stopNumberChange(form.getElement($event).value)"
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [id]='controlName'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              @if (form.roadNumber.value && form.roadSide.value) {
                <option
                  *ngFor="let item of ((listOfStops() || []) | filterData: form.roadNumber.value : false : 'roadNumber') | filterData: form.roadSide.value : false : 'roadSide'"
                  [value]="item.stopNumber">
                  {{ item.stopNumber }}
                </option>
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"stopName" as controlName'>
            <label [for]='controlName'>
              Nazwa przystanku *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu nazwę przystanku'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"location" as controlName'>
            <label [for]='controlName'>
              Lokalizacja - kilometraż *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu lokalizację - kilometraż'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
      <div class="form-actions">
        @if (showCancel) {
          <button type="button" class="btn btn-secondary" (click)="onCancel()">
            <i class="fa fa-trash" aria-hidden="true"></i>Anuluj
          </button>
        }
        <button type="button" class="btn btn-secondary" (click)="onSubmit()">
          @if (!edit) {
            <i class="fa fa-plus" aria-hidden="true"></i>Dołącz do wniosku
          } @else {
            <i class="fa fa-save"></i>Zaktualizuj dane
          }
        </button>
      </div>
    </form>
  </div>
</div>
